<template>
	<div class="article-edit main-content editor">
		<el-row>
			<el-col style="width: 80px;">标题</el-col>
			<el-col style="width: 300px;">
				<el-input v-model="articleData.title" size="small"></el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col style="width: 80px;">文章类型</el-col>
			<el-col style="width: 200px;">
				<el-select v-model="articleData.type">
					<el-option :value="1" label="帮助文章"></el-option>
					<!-- <el-option :value="2" label="消息文章"></el-option>
					<el-option :value="3" label="活动文章"></el-option> -->
				</el-select>
			</el-col>
		</el-row>
		<el-row>
			<el-col style="width: 80px;">显示状态</el-col>
			<el-col style="width: 300px;">
				<el-radio v-model="articleData.status" :label="1">显示</el-radio>
				<el-radio v-model="articleData.status" :label="2">禁用</el-radio>
			</el-col>
		</el-row>
		<el-row>
			<el-col style="width: 80px;">浏览量</el-col>
			<el-col style="width: 300px;">
				<el-input v-model="articleData.review" size="small"></el-input>
			</el-col>
		</el-row>
		<el-row>
			<el-col style="width: 80px;">内容</el-col>
			<el-col style="width: calc(100% - 80px)">
				<quill-editor v-model="articleData.content" ref="quillEditor" :options="editorOption"></quill-editor>
			</el-col>
		</el-row>

		<el-row style="margin-top:20px;">
			<el-col style="padding-left: 80px; text-align: left;">
				<el-button v-if="article_id" size="small" type="primary" @click="handleEdit">提交修改</el-button>
				<el-button v-else size="small" type="primary" @click="handleSubmit">提交文章</el-button>
				<el-button type="danger" size="small" @click="handleDelete">删除文章</el-button>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { postData, patchData, delData, getData, server } from '../../http'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
import * as Quill from 'quill'

import { ImageExtend, QuillWatch } from 'quill-image-extend-module'
import ImageResize from 'quill-image-resize-module'

import { getCookie } from '../../utils/cookie'

const fonts = [
	'SimSun',
	'SimHei',
	'Microsoft-YaHei',
	'KaiTi',
	'FangSong',
	'Arial',
	'Times-New-Roman',
	'sans-serif'
]
const Font = Quill.import('formats/font')
Font.whitelist = fonts

Quill.register(Font, true)
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register('modules/imageResize', ImageResize)

export default {
	data() {
		return {
			articleData: {
				title: '',
				review: 0,
				status: 1,
				content: '',
				type: 1
			},
			editorOption: {
				placeholder: '编辑文章内容',
				modules: {
					ImageExtend: {
						loading: true,
						name: 'file',
						action: `${server}file`,
						change: (xhr, formData) => {
							xhr.setRequestHeader(
								'Authorization',
								'Bearer ' + getCookie('access_token')
							)
							formData.append('disk', 'article')
						},
						response: res => {
							return res.path
						}
					},
					imageResize: {},
					toolbar: {
						container: [
							['bold', 'italic', 'underline', 'strike'],
							['blockquote', 'code-block'],

							[{ header: 1 }, { header: 2 }],
							[{ list: 'ordered' }, { list: 'bullet' }],
							[{ script: 'sub' }, { script: 'super' }],
							[{ indent: '-1' }, { indent: '+1' }],
							[{ direction: 'rtl' }],

							[{ size: ['small', false, 'large', 'huge'] }],
							[{ header: [1, 2, 3, 4, 5, 6, false] }],

							[{ color: [] }, { background: [] }],
							[{ font: fonts }],

							[{ align: [] }],

							['clean'],
							['image', 'video']
						],
						handlers: {
							image: function() {
								QuillWatch.emit(this.quill.id)
							}
						}
					}
				}
			}
		}
	},
	components: {
		quillEditor
	},
	props: {
		article_id: String
	},
	methods: {
		handleSubmit() {
			if (!this.articleData.title) {
				this.$message.error('请填写文章标题')
				return
			}
			if (!this.articleData.content) {
				this.$message.error('文章内容不能为空')
				return
			}
			const { title, content, status, review, type } = this.articleData
			postData('articles', {
				title,
				content,
				status,
				review,
				type
			}).then(
				() => {
					this.$message.success('提交成功')
					this.$router.push({ path: '/article' })
				}
			)
		},
		handleEdit() {
			const { title, content, status, review, type } = this.articleData
			patchData(`articles/${this.article_id}`, {
				title,
				content,
				status,
				review,
				type
			}).then(
				() => {
					this.$message.success('修改成功')
					this.$router.push({ path: '/article' })
				}
			)
		},
		handleDelete() {
			delData(`articles/${this.article_id}`).then(
				() => {
					this.$message.success('删除成功')
					this.$router.push({ path: '/article' })
				}
			)
		},
		getArticleDetail(id) {
			getData(`articles/${id}`).then(
				res => {
					this.articleData = res.data
				}
			)
		}
	},
	created() {
		if (this.article_id) {
			this.getArticleDetail(this.article_id)
		}
	}
}
</script>

<style lang="less">
.editor {
	text-align: left;
	.ql-container {
		height: 540px;
	}
	.el-row {
		line-height: 30px;
		margin-bottom: 20px;
		font-size: 14px;
	}
	.ql-toolbar {
		line-height: 22px;
		text-align: left;
	}
}
</style>
